// extracted by mini-css-extract-plugin
module.exports = {"CompletedList":"CompletedList_CompletedList__2XKws","Accordion":"CompletedList_Accordion__11Esh","ChevronRotate":"CompletedList_ChevronRotate__3vfuj"};